import { Root, Trigger, Content, Portal, Anchor } from '@radix-ui/react-popover';
import { type ComponentProps, type ReactElement } from 'react';
import { cn } from '@avanta/shared/utils/cn';
import { popoverStyles } from './styles';

const Popover = ({ ...props }: ComponentProps<typeof Root>): ReactElement => (
  <Root data-slot="popover" {...props} />
);

const PopoverTrigger = ({ ...props }: ComponentProps<typeof Trigger>): ReactElement => (
  <Trigger data-slot="popover-trigger" {...props} />
);

const PopoverContent = ({
  className,
  align = 'center',
  sideOffset = 4,
  ...props
}: ComponentProps<typeof Content>): ReactElement => (
  <Portal>
    <Content
      data-slot="popover-content"
      align={align}
      sideOffset={sideOffset}
      className={cn(popoverStyles.popoverContent, 'notranslate', className)}
      translate="no"
      {...props}
    />
  </Portal>
);

const PopoverAnchor = ({ ...props }: ComponentProps<typeof Anchor>): ReactElement => (
  <Anchor data-slot="popover-anchor" {...props} />
);

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor };
